<template lang="html">
  <chart :chartData="currentDataChart" :options="options" v-if="currentDataChart !== undefined"></chart>
  <spinner v-else></spinner>
</template>

<script>
import Chart from '@/pages/statistics/components/graphiques/BarChart.vue'
import Spinner from '@/components/common/spinner.vue'
import * as R from 'ramda'
import {statusLabel} from '@/helpers/labels'

export default {
  props: ['showAmountNotNumber', 'chartData'],
  data () {
    return {
      options: undefined
    }
  },
  components: {
    'chart': Chart,
    'spinner': Spinner
  },
  created () {
    this.options = {
      responsive: true,
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            stepSize: 1,
            beginAtZero: true
          }
        }]
      },
      legend: {
        display: false,
        fullWidth: false,
        align: 'start'
      }
    }
  },
  computed: {
    currentDataChart () {
      if (this.chartData !== undefined) {
        return this.makeChartData(this.chartData)
      }
    }
  },
  watch: {
    showAmountNotNumber: {
      handler () {
        if (this.$engine.monitoring.graphByStatus !== undefined) {
          this.chartData = this.makeChartData(this.$engine.monitoring.graphByStatus)
        }
      }
    }
  },
  methods: {
    makeChartData (rawData) {
      let data = {
        labels: [],
        datasets: []
      }
      // Status not to merge, label changing according to the direction
      let creditorKeys = R.keys(rawData.creditor)
      let debtorKeys = R.keys(rawData.debtor)
      data.labels = this.getDataLabels(creditorKeys, debtorKeys)

      let dataset = {data: [], label: '', backgroundColor: [], borderColor: []}
      this.makeDataSet(dataset, rawData.creditor, rawData.debtor)
      this.dataSetDecorate(dataset)
      data.datasets = [dataset]
      return data
    },
    getDataLabels (senderKeys, receiverKeys) {
      let labels = []
      for (let key in senderKeys) {
        labels.push(statusLabel(this.$i18n, senderKeys[key], '0'))
      }
      for (let key in receiverKeys) {
        if (!labels.includes(statusLabel(this.$i18n, receiverKeys[key], '1'))) {
          labels.push(statusLabel(this.$i18n, receiverKeys[key], '1'))
        }
      }
      return labels
    },
    makeDataSet (dataset, senderData, receiverData) {
      let notMergeStatus = ['Doc_1', 'Doc_2', 'Doc_10', 'Doc_11']
      let creditorKeys = R.keys(senderData)
      for (let sndrStatus in senderData) {
        if (sndrStatus) {
          dataset.data = R.append(senderData[sndrStatus].amount, dataset.data)
        }
      }
      // add debtor dataset
      for (let rcvrStatus in receiverData) {
        if (creditorKeys.find(item => item === rcvrStatus) && !notMergeStatus.includes(rcvrStatus)) {
          dataset.data[creditorKeys.indexOf(rcvrStatus)] = parseInt(dataset.data[creditorKeys.indexOf(rcvrStatus)]) + parseInt(receiverData[rcvrStatus].amount)
        } else {
          dataset.data = R.append(receiverData[rcvrStatus].amount, dataset.data)
        }
      }
    },
    dataSetDecorate (dataset) {
      dataset.label = this.$i18n.t('graph.rcvd')
      dataset.backgroundColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)'
      ]
      dataset.borderColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)'
      ]
    }
  }
}
</script>
